import { Card } from '@/components/ui/card';

const AffiliateDisclosure = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="p-8 md:p-12">
          <h1 className="text-4xl font-bold text-stone-900 mb-6">Affiliate Disclosure</h1>
          <p className="text-sm text-stone-500 mb-8">Last Updated: January 2025</p>

          <div className="prose prose-stone max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">FTC Disclosure</h2>
              <p className="text-stone-700 leading-relaxed">
                Garden & Greenhouse ("we," "us," or "our") participates in various affiliate marketing programs, 
                which means we may earn commissions on purchases made through our links to retailer sites. 
                This disclosure is made in accordance with the Federal Trade Commission's 16 CFR, Part 255: 
                "Guides Concerning the Use of Endorsements and Testimonials in Advertising."
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">What Are Affiliate Links?</h2>
              <p className="text-stone-700 leading-relaxed">
                Affiliate links are special URLs that contain a unique tracking code. When you click on an affiliate 
                link and make a purchase, we may receive a commission from the merchant at no additional cost to you. 
                These commissions help us maintain and improve our website, create valuable content, and continue 
                providing free gardening resources to our community.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">Our Affiliate Partners</h2>
              <p className="text-stone-700 leading-relaxed mb-4">
                We partner with reputable companies in the gardening industry, including but not limited to:
              </p>
              <ul className="list-disc list-inside text-stone-700 space-y-2">
                <li>Seeds Now</li>
                <li>West Coast Seeds</li>
                <li>Hoss Tools</li>
                <li>Nature Hills Nursery</li>
                <li>AeroGarden</li>
                <li>Botanical Interests</li>
                <li>Succulents Box</li>
                <li>Amazon Associates</li>
                <li>Other gardening and home improvement retailers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">Our Commitment to You</h2>
              <p className="text-stone-700 leading-relaxed mb-4">
                We are committed to maintaining your trust and confidence. Here's what you should know:
              </p>
              <ul className="list-disc list-inside text-stone-700 space-y-2">
                <li><strong>Honest Recommendations:</strong> We only recommend products and services we believe will provide value to our readers.</li>
                <li><strong>No Extra Cost:</strong> Using our affiliate links does not increase the price you pay for any product or service.</li>
                <li><strong>Unbiased Reviews:</strong> Our editorial content is not influenced by affiliate relationships. We maintain editorial independence.</li>
                <li><strong>Transparent Disclosure:</strong> We clearly disclose affiliate relationships and mark sponsored content.</li>
                <li><strong>Quality Focus:</strong> We prioritize recommending quality products that serve our readers' gardening needs.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">How We Choose Partners</h2>
              <p className="text-stone-700 leading-relaxed">
                We carefully select affiliate partners based on product quality, customer service reputation, 
                commission structure, and relevance to our audience. We regularly review our partnerships to 
                ensure they continue to meet our standards and serve our readers' interests.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">Commission Structure</h2>
              <p className="text-stone-700 leading-relaxed">
                Commission rates vary by partner and product category, typically ranging from 5% to 25% of the 
                purchase price. These commissions do not affect the content of our recommendations or the price 
                you pay as a consumer.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">Your Privacy</h2>
              <p className="text-stone-700 leading-relaxed">
                When you click on an affiliate link, the merchant may use cookies to track your purchase and 
                attribute the commission to us. This tracking is subject to the merchant's privacy policy. 
                We do not have access to your personal or payment information when you make a purchase through 
                our affiliate links. Please refer to our Privacy Policy for more information about how we handle data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">Questions?</h2>
              <p className="text-stone-700 leading-relaxed">
                If you have any questions about our affiliate relationships or this disclosure, please contact us 
                at contact@gardenandgreenhouse.com.
              </p>
            </section>

            <section className="bg-emerald-50 p-6 rounded-lg mt-8">
              <p className="text-sm text-stone-600">
                <strong>Note:</strong> This affiliate disclosure is subject to change. We encourage you to review 
                this page periodically for updates. By using our website and clicking on affiliate links, you 
                acknowledge and accept this disclosure.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AffiliateDisclosure;
